import { View, Text, styled } from 'tamagui'

const PreviewCard = styled(View, {
  borderLeftWidth: 3,
  borderLeftColor: '$accent',
  backgroundColor: '$sidebar',
  borderRadius: '$borderRadiusSm',
  paddingHorizontal: 12,
  paddingVertical: 8,
  marginTop: 4,
  maxWidth: 400,
})

const SiteName = styled(Text, {
  fontFamily: '$fontBody',
  fontSize: 11,
  color: '$color8',
  textTransform: 'uppercase',
  letterSpacing: 0.5,
  marginBottom: 2,
})

const PreviewTitle = styled(Text, {
  fontFamily: '$fontBody',
  fontSize: 14,
  fontWeight: '600',
  color: '$accent',
  cursor: 'pointer',
  hoverStyle: {
    textDecorationLine: 'underline',
  },
  marginBottom: 2,
})

const PreviewDescription = styled(Text, {
  fontFamily: '$fontBody',
  fontSize: 13,
  color: '$sidebarMuted',
  lineHeight: 18,
})

// Hardcoded link preview data for mock purposes
const PREVIEW_DATA: Record<string, { site: string; title: string; description: string }> = {
  'arcus.space': {
    site: 'arcus.space',
    title: 'Arcus — Privacy-first communication',
    description: 'A real-time chat and voice platform that respects your privacy. No ID verification, E2E encrypted voice, spatial audio.',
  },
  'github.com': {
    site: 'GitHub',
    title: 'GitHub — Where the world builds software',
    description: 'Millions of developers and companies build, ship, and maintain their software on GitHub.',
  },
  'crates.io': {
    site: 'crates.io',
    title: 'crates.io — Rust Package Registry',
    description: 'The Rust community\'s crate registry for sharing and discovering Rust libraries.',
  },
}

function getPreviewData(url: string) {
  for (const [pattern, data] of Object.entries(PREVIEW_DATA)) {
    if (url.includes(pattern)) return data
  }
  return null
}

interface LinkPreviewProps {
  url: string
}

export function LinkPreview({ url }: LinkPreviewProps) {
  const data = getPreviewData(url)
  if (!data) return null

  return (
    <PreviewCard>
      <SiteName>{data.site}</SiteName>
      <PreviewTitle onPress={() => window.open(url, '_blank', 'noopener,noreferrer')}>
        {data.title}
      </PreviewTitle>
      <PreviewDescription>{data.description}</PreviewDescription>
    </PreviewCard>
  )
}
